// HDS Thumbnails: slideshow main + synced thumbnail strip (overlaid bottom-centre).
if (!customElements.get('hds-thumbnail-gallery')) {
  customElements.define(
    'hds-thumbnail-gallery',
    class HdsThumbnailGallery extends HTMLElement {
      connectedCallback() {
        this.slideshow = this.querySelector('slideshow-component');
        this.thumbs = Array.from(this.querySelectorAll('[data-thumbnail]'));
        this.slides = Array.from(this.querySelectorAll('.slideshow__slide[data-media-id]'));
        this.region = this.querySelector('.hds-thumbnails__scroll');
        if (!this.slideshow || !this.thumbs.length) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(thumb.dataset.thumbnail);
          });
        });

        // Keep the active thumb in sync when the slideshow changes (arrows, swipe, variant change).
        this.observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.target.getAttribute('aria-hidden') === 'false') {
              this.setActive(mutation.target.dataset.mediaId);
            }
          }
        });
        this.slides.forEach((slide) =>
          this.observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] })
        );

        // Hidden arrows drop the counter, so the theme's update() throws mid-constructor and never binds swipe.
        if (this.slideshow.pageTotalElement == null) this.slideshow.pageTotalElement = document.createElement('span');
        if (this.slideshow.currentPageElement == null) this.slideshow.currentPageElement = document.createElement('span');
        this.bindSwipe();
      }

      // Swipe the main image to change slides (touch + mouse drag).
      bindSwipe() {
        let startX = null;
        const threshold = 40;
        const end = (x) => {
          if (startX == null) return;
          const dx = x - startX;
          startX = null;
          if (Math.abs(dx) < threshold || typeof this.slideshow.calculateFromDirection !== 'function') return;
          this.slideshow.calculateFromDirection(dx < 0 ? 'next' : 'previous');
        };
        this.slideshow.addEventListener('touchstart', (e) => (startX = e.changedTouches[0].clientX), { passive: true });
        this.slideshow.addEventListener('touchend', (e) => end(e.changedTouches[0].clientX), { passive: true });
        this.slideshow.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') startX = e.clientX; });
        this.slideshow.addEventListener('pointerup', (e) => { if (e.pointerType === 'mouse') end(e.clientX); });
      }

      select(id) {
        const slide = this.slideshow.querySelector(`[data-media-id="${id}"]`);
        if (slide && typeof this.slideshow.jumpToSlide === 'function') {
          this.slideshow.jumpToSlide(slide);
        }
        this.setActive(id);
      }

      setActive(id) {
        this.thumbs.forEach((thumb) => {
          const active = thumb.dataset.thumbnail === String(id);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active) this.scrollThumbIntoView(thumb);
        });
      }

      // Centre the active thumb within the strip only — never scroll the page.
      scrollThumbIntoView(thumb) {
        if (!this.region) return;
        const t = thumb.getBoundingClientRect();
        const r = this.region.getBoundingClientRect();
        this.region.scrollBy({ left: t.left + t.width / 2 - (r.left + r.width / 2), behavior: 'smooth' });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
